module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar-scroll"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "content-header content-header-fullrow px-15"
  }, [_c('div', {
    staticClass: "content-header-section text-center align-parent"
  }, [_c('button', {
    staticClass: "btn btn-circle btn-dual-secondary d-lg-none align-v-r",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-times text-danger"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "content-side content-side-full content-side-user px-10 align-parent"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "img-link",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline mt-10"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "link-effect text-dual-primary-dark font-size-xs font-w600 text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "link-effect text-dual-primary-dark",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "si si-logout"
  })])])])])]), _vm._v(" "), (_vm.user.role === 'admin') ? _c('admin-sidebar') : _vm._e(), _vm._v(" "), (_vm.user.role === 'orderpicker') ? _c('order-picker-sidebar') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header-item"
  }, [_c('a', {
    staticClass: "link-effect font-w700",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "si si-check text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-xl text-dual-primary-dark"
  }, [_vm._v("VM")]), _c('span', {
    staticClass: "font-size-xl text-primary"
  }, [_vm._v("Control")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6df4526c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/partials/Sidebar.vue
// module id = 733
// module chunks = 1